<!-- [인라인] 대상 영역 표시 -->
<template>
  <span>
    <b-badge
      :id="`guide-text-${contentType}-${conditionType}`"
      variant="light-secondary"
      style="padding: 0px; margin-left: 5px;"
      hover
    >
      <feather-icon
        icon="InfoIcon"
      />
    </b-badge>
    <b-tooltip
      :target="`guide-text-${contentType}-${conditionType}`"
      placement="right"
      variant="dark"
    >
      <dd
        v-for="(node, index) in displayNodeList"
        :key="index"
        class="text-left m-0"
      >
        {{ `${node.formName} ▶ ${node.routedPageName} ▶ [ ${node.displayNode} ]` }}
      </dd>
    </b-tooltip>
  </span>
</template>

<script>
import {
  BBadge, VBTooltip, BButton, BTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { getCodeLabel } from '@/common/custom/content-type'
import { ref, onMounted, computed } from '@vue/composition-api'

export default {
  components: {
    BBadge,
    BTooltip,
    BButton,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    contentType: {
      type: Number,
      default: null,
      required: true,
    },
    conditionType: {
      type: Number,
      default: null,
      required: true,
    },
    showGuide: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  mounted() {
  },
  setup(props) {
    const displayInfo = [
      /* contentType
        1 : 약품정보
        2 : 메디컬트렌드
        3 : 설문조사
        4 : WeeklyChoice
        5 : 웹세미나
        6 : 공지사항
        7 : 이벤트
        8 : 간편처방등록
       */
      /* conditionType
        1 : 진료과
        2 : 지역
        3 : 환자연령
        4 : 타겟그룹
        10 : 노출조건 (진료과,지역,타겟그룹 = 1,2,4)
        901 : 세팅 정보로 닥터인포에 노출하기 (약품정보에만 있음)
       */
      // {
      //   contentType: [7, 6], conditionType: [1, 4], formName: '메인', routedPageName: '대시보드', displayNode: 'Popup ▷ 공지',
      // },
      {
        contentType: [1], conditionType: [1, 2, 4, 10], formName: '메인', routedPageName: '대시보드', displayNode: '약품정보',
      },
      {
        contentType: [3], conditionType: [1, 2, 4, 10], formName: '메인', routedPageName: '대시보드', displayNode: '설문조사',
      },
      {
        contentType: [1, 2, 3, 5, 8], conditionType: [1, 2, 4, 10], formName: '메인', routedPageName: '대시보드', displayNode: '텍스트 배너',
      },
      {
        contentType: [1, 2, 3, 5], conditionType: [1, 2, 4, 10], formName: '메인', routedPageName: '대시보드', displayNode: '좌측 배너',
      },
      {
        contentType: [1, 2, 3, 5], conditionType: [1, 2, 4, 10], formName: '메인', routedPageName: '대시보드', displayNode: '우측 배너',
      },
      {
        contentType: [8], conditionType: [1, 2, 4, 10], formName: '메인', routedPageName: '대시보드', displayNode: '간편처방등록',
      },
      // {
      //   contentType: [3], conditionType: [1, 2, 4, 10], formName: '메인', routedPageName: '대시보드', displayNode: '참여 가능한 설문 조사',
      // },
      {
        contentType: [2], conditionType: [1, 2, 4, 10], formName: '메인', routedPageName: '메디컬트렌드', displayNode: '메디컬트렌드 목록',
      },
      {
        contentType: [2], conditionType: [], formName: '메인', routedPageName: '메디컬트렌드', displayNode: 'Popup ▷ 메디컬트렌드 상세',
      },
      {
        contentType: [7], conditionType: [], formName: '메인', routedPageName: '메디컬트렌드', displayNode: 'Popup ▷ 메디컬트렌드 이벤트',
      },
      {
        contentType: [], conditionType: [], formName: '메인', routedPageName: '메디컬트렌드', displayNode: 'Popup ▷ 컨텐츠 댓글 투표지',
      },
      {
        contentType: [], conditionType: [], formName: '메인', routedPageName: '메디컬트렌드', displayNode: 'Popup ▷ 컨텐츠 댓글',
      },
      {
        contentType: [1], conditionType: [1, 2, 4, 10, 901], formName: '메인', routedPageName: '약품정보', displayNode: '약품정보 목록',
      },
      {
        contentType: [1], conditionType: [], formName: '메인', routedPageName: '약품정보', displayNode: 'Popup ▷ 약품정보 상세',
      },
      {
        contentType: [2], conditionType: [1, 2, 4, 10], formName: '메인', routedPageName: '약품정보', displayNode: 'Popup ▷ 메디컬트렌드 약품정보 하단배너',
      },
      {
        contentType: [], conditionType: [], formName: '메인', routedPageName: '약품정보', displayNode: 'Popup ▷ 컨텐츠 댓글 투표지',
      },
      {
        contentType: [], conditionType: [], formName: '메인', routedPageName: '약품정보', displayNode: 'Popup ▷ 컨텐츠 댓글',
      },
      {
        contentType: [5], conditionType: [1, 2, 4, 10], formName: '메인', routedPageName: '웹 심포지엄', displayNode: 'Tab [ 제약 웹 세미나 ] ▷ 웹세미나 캘린더',
      },
      {
        contentType: [5], conditionType: [], formName: '메인', routedPageName: '웹 심포지엄', displayNode: 'Tab [ 제약 웹 세미나 ] ▷ Popup ▷ 웹세미나 상세',
      },
      {
        contentType: [], conditionType: [], formName: '메인', routedPageName: '웹 심포지엄', displayNode: 'Tab [ KMA 연수 교육 ] ▷ KMA 연수 교육 목록',
      },
      {
        contentType: [], conditionType: [], formName: '메인', routedPageName: '웹 심포지엄', displayNode: 'Tab [ KMA 연수 교육 ] ▷ Popup ▷ KMA 상세',
      },
      {
        contentType: [5], conditionType: [], formName: '메인', routedPageName: '웹 심포지엄', displayNode: 'Tab [ MY 세미나 ] ▷ MY 세미나 캘린더',
      },
      {
        contentType: [5], conditionType: [], formName: '메인', routedPageName: '웹 심포지엄', displayNode: 'Tab [ MY 세미나 ] ▷ Popup ▷ my세미나 상세',
      },
      {
        contentType: [5], conditionType: [], formName: '메인', routedPageName: '웹 심포지엄', displayNode: 'Tab [ MY 세미나 ] ▷ Popup ▷ my세미나 상세',
      },
      {
        contentType: [3, 4], conditionType: [1, 2, 4, 10], formName: '메인', routedPageName: '설문조사', displayNode: '설문조사 목록',
      },
      {
        contentType: [3], conditionType: [], formName: '메인', routedPageName: '설문조사', displayNode: 'Popup ▷ 설문조사 상세',
      },
      {
        contentType: [2, 7], conditionType: [1, 2, 4, 10], formName: '메인', routedPageName: '설문조사', displayNode: 'Popup ▷ Popup ▷ 설문조사 보상완료 삽입배너',
      },
      {
        contentType: [4], conditionType: [], formName: '메인', routedPageName: '설문조사', displayNode: 'Popup ▷ Weekly Choice 상세',
      },
      {
        contentType: [], conditionType: [], formName: '메인', routedPageName: '설문조사', displayNode: 'Popup ▷ 컨텐츠 댓글 투표지',
      },
      {
        contentType: [], conditionType: [], formName: '메인', routedPageName: '설문조사', displayNode: 'Popup ▷ 컨텐츠 댓글',
      },
      {
        contentType: [7], conditionType: [], formName: '메인', routedPageName: '이벤트', displayNode: '이벤트 목록',
      },
      {
        contentType: [7], conditionType: [], formName: '메인', routedPageName: '이벤트', displayNode: '이벤트 상세',
      },
      {
        contentType: [], conditionType: [], formName: '메인', routedPageName: '이벤트', displayNode: '컨텐츠 댓글 투표지',
      },
      {
        contentType: [], conditionType: [], formName: '메인', routedPageName: '이벤트', displayNode: '컨텐츠 댓글',
      },
      {
        contentType: [6], conditionType: [], formName: '메인', routedPageName: '공지사항', displayNode: '공지사항 목록',
      },
      {
        contentType: [6], conditionType: [], formName: '메인', routedPageName: '공지사항', displayNode: '공지사항 상세',
      },
      {
        contentType: [], conditionType: [], formName: '메인', routedPageName: '공지사항', displayNode: '컨텐츠 댓글 투표지',
      },
      {
        contentType: [], conditionType: [], formName: '메인', routedPageName: '공지사항', displayNode: '컨텐츠 댓글',
      },
      {
        contentType: [2, 1, 3, 8], conditionType: [1, 2, 3, 4, 10], formName: '알림', routedPageName: '하단팝업', displayNode: '처방팝업',
      },
      {
        contentType: [2, 1, 3], conditionType: [1, 2, 4, 10], formName: '알림', routedPageName: '하단팝업', displayNode: '스케줄팝업',
      },
      {
        contentType: [2, 1, 3], conditionType: [1, 2, 3, 4, 10], formName: '알림', routedPageName: '하단팝업', displayNode: '처방스케줄팝업',
      },
      {
        contentType: [1], conditionType: [10], formName: '알림', routedPageName: '하단팝업', displayNode: '환자타입조회팝업',
      },
      {
        contentType: [5], conditionType: [], formName: '알림', routedPageName: '하단팝업', displayNode: '웹세미나시청팝업',
      },
      {
        contentType: [1], conditionType: [1, 2, 4, 10], formName: '진료실', routedPageName: '라이브뉴스', displayNode: '라이브DI',
      },
    ]

    function currentGuide() {
      const currentDisplayNodes = displayInfo
        .filter(x => x.contentType.includes(props.contentType) && x.conditionType.includes(props.conditionType))
      // .map(r => `${r.formName} ▶ ${r.routedPageName} ▶ [ ${r.displayNode} ]`)

      return currentDisplayNodes
    }

    const displayNodeList = ref(currentGuide())

    return {
      getCodeLabel,
      displayNodeList,
    }
  },
}
</script>

<style lang="scss">
// v-b-tooltip 너비 조정
.tooltip .tooltip-inner{
  max-width: 440px !important;
}
</style>
